// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__2ocwj","page":"Main_page__2ypj2"};